import script from "./MainPageBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPageBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MainPageBanner.vue?vue&type=style&index=0&id=6dbbc478&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbbc478"]])

export default __exports__